import { Component, HostListener, OnInit } from '@angular/core';
import { CmHelp, ContentType } from '../shared/model/cm/managed-content.model';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { UserSessionService } from "../shared/service/user-session.service";
import { Brandmark } from '../shared/model/ui/brandmark';
import { COMPANY_DATA_THEME } from "../shared/global-constants";
import { WindowRef } from '../shared/service/window.service';
import { ModalService } from '../shared/service/modal.service';
import { GoogleAnalyticsService } from '../shared/service/google-analytics.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NavbarComponent implements OnInit {
  
  contactUsContent: CmHelp;

  public contactUsContentHeading: string;
  public contactUsContentBody: string;
  public isStandardTheme: boolean = true;

  public innerWidth: number = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
  
  public readonly utilityNavItems = [
    {
      iconName: "question-circle",
      keyId: `util-nav-help`,
      label: 'Help',
      clickAction: () => this.openContactUsModal()
    }
  ];

  public clickNavBarHelpEvent = {
    action: "button_click",
    category: "nav-bar",
    name: "help-button",
  };

  public brandmark: Brandmark;

  public isNwm: boolean = false;

  constructor(public googleAnalyticsService: GoogleAnalyticsService,
    private cmService: ManagedContentService,
    private userSessionService: UserSessionService,
    private modalService: ModalService,
    private windowService: WindowRef) { }

  ngOnInit(): void {
    this.contactUsContent = this.cmService.getContentById(ContentType.HELP, "eeoi-contact-us");
    
    if(this.userSessionService.data.dataTheme === COMPANY_DATA_THEME.NM){
      this.isStandardTheme = false;
    } else {
      this.isStandardTheme = true;
    }

    if(this.contactUsContent){
      this.contactUsContentHeading = this.contactUsContent.title;
      this.contactUsContentBody = this.contactUsContent.body;
      if(this.userSessionService.data.companyId == 'NM'){
        this.contactUsContent = this.cmService.getContentById(ContentType.HELP, "eeoi-contact-us-nm");
        this.contactUsContentHeading = this.contactUsContent.title;
        this.contactUsContentBody = this.contactUsContent.body;
      }
    }

    this.windowService.nativeDocument
      .querySelector('body')
      .addEventListener('click', (event: Event) => this.onClick(event));
    
  }

  iconClick(){
    if (this.userSessionService.data.dataTheme === COMPANY_DATA_THEME.NM){
      window.location.href = 'https://www.northwesternmutual.com';
    } else {
      window.location.href = 'https://www.standard.com';
    }
  }

  openContactUsModal(){

    this.googleAnalyticsService.sendCustomEvent(this.clickNavBarHelpEvent);
    this.modalService.showModal('prism-ui-modal-contact-us-modal');
  }

  closeContactUsModal(){
    this.onCancelModal();
  }

  onCancelModal(){
    this.modalService.closeModal('prism-ui-modal-contact-us-modal');
  }

  onClick(event: Event) {
    const modal = this.windowService.nativeDocument.getElementById(
      'prism-ui-modal-contact-us-modal'
    );

    if (modal && event.target === modal) {
      this.onCancelModal();
    }
  }

}